<template>
  <section class="index">
    <div class="container">
      <div class="gc-page-container">
        <div class="container-center">
          <el-card style="margin-bottom: 20px;">
            <h1 class="up-t">最新更新</h1>
            <h2 class="up-date">2025年6月20日</h2>
            <h2 class="up-title">专属链接支持查询回退状态</h2>
            <p class="up-desc">
              每条新增的成功记录，可能在若干天后，由于质量问题被回退。我们在每条回答记录上提供了回退状态，供渠道用户查看。此外，我们提供了查询全部回退记录的入口，方便渠道用户一次性获取近期被回退的记录。
            </p>
            <p style="height: 20px;"></p>

            <h2 class="up-date">2025年1月6日</h2>
            <h2 class="up-title">肥牛卷专属推广链接开放申请</h2>
            <p class="up-desc">
              在本页面肥牛专区点击申请按钮，获取肥牛卷专属推广链接。专属链接支持字段&f=，填写上相应的数字符后，就可以给不同的好友创建专属肥牛卷回答链接，如以下示例
            </p>
            <p class="up-desc up-link">
              http://open.51point.com/q/link/c?u=xxxxxxx&f=002
            </p>
            <p class="up-desc" style="margin-bottom: 20px;">
              添加后，可分享给某个指定好友，该好友在这个链接下的回答记录，都会通过来源用户002进行标识，方便您之后给予他奖励。
            </p>
            <p style="height: 20px;"></p>
            <h2 class="up-date">2024年12月26日</h2>
            <h2 class="up-title">专属链接新增来源用户字段，方便推广</h2>
            <p class="up-desc">
              获得专属链接的用户，可以在链接的末尾添加
              字段&f=并填写上相应的数字符，如以下示例
            </p>
            <p class="up-desc up-link">
              http://open.51point.com/q/link/getLink?u=xxxxxxxx&f=001
            </p>
            <p class="up-desc" style="margin-bottom: 20px;">
              添加后，可分享给某个指定好友，该好友在这个链接下的回答记录，都会通过来源用户001进行标识，方便您之后给予他奖励。
            </p>
            <!-- <p class="up-more" @click="onToLog">查看更多 ></p> -->
          </el-card>

          <el-card>
            <div
              style="font-size: 18px;margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;">
              <div>鸡肉卷专属链接</div>
              <div @click.stop="onTapJrModal" style="color: #409eff;cursor: pointer;">鸡肉回退列表</div>
            </div>
            <el-row v-if="linkInfo && linkInfo.jr" style="margin: 20px 0;">
              <div @click.stop="onTapCopy(1)" style="color: #409eff;cursor: pointer;">
                {{ linkInfo.jr }}
              </div>
            </el-row>
            <el-row style="margin-bottom: 10px;">
              <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="f3" clearable></el-input>
              <el-select v-model="s3" placeholder="请选择回答结果" style="width: 250px;margin-left: 10px;">
                <el-option v-for="e in ss3" :key="e.value" :label="e.label" :value="e.value"></el-option>
              </el-select>
              <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh"
                @click="onReset3">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="onSearch3">搜索</el-button>
            </el-row>

            <el-row>
              <el-table :data="list3" border stripe>
                <el-table-column type="index" :index="index" :span="2"></el-table-column>
                <el-table-column prop="prid" label="问卷ID"></el-table-column>
                <el-table-column prop="nickName" label="昵称"></el-table-column>
                <el-table-column prop="fromuid" label="来源用户"></el-table-column>
                <el-table-column label="回答状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.answerstatus == 2" type="success">成功</el-tag>
                    <el-tag v-else-if="scope.row.answerstatus == 4" type="warning">失败</el-tag>
                    <el-tag v-else-if="scope.row.answerstatus == 5" type="danger">配额满</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="是否回退">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
                    <el-tag v-else type="warning">未回退</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="addtime" label="回答时间"></el-table-column>
              </el-table>
            </el-row>

            <el-row>
              <el-pagination background layout="prev, pager, next" :page-size="10" :page-count="pages3"
                style="margin-top: 20px;" @current-change="currentChange3"></el-pagination>
            </el-row>
          </el-card>

          <el-card style="margin-top: 20px;">
            <div
              style="font-size: 18px;margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;">
              <div>即付问卷专属链接</div>
              <div @click.stop="onTapJFModal" style="color: #409eff;cursor: pointer;">即付回退列表</div>
            </div>
            <el-row v-if="linkInfo && linkInfo.jf" style="margin: 20px 0;">
              <div @click.stop="onTapCopy(1)" style="color: #409eff;cursor: pointer;">
                {{ linkInfo.jf }}
              </div>
            </el-row>
            <el-row style="margin-bottom: 10px;">
              <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="f" clearable></el-input>
              <el-select v-model="s" placeholder="请选择回答结果" style="width: 250px;margin-left: 10px;">
                <el-option v-for="e in ss" :key="e.value" :label="e.label" :value="e.value"></el-option>
              </el-select>
              <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh" @click="onReset">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
            </el-row>

            <el-row>
              <el-table :data="list" border stripe>
                <el-table-column type="index" :index="index" :span="2"></el-table-column>
                <el-table-column prop="prid" label="问卷ID"></el-table-column>
                <el-table-column prop="nickName" label="昵称"></el-table-column>
                <el-table-column prop="fromuid" label="来源用户"></el-table-column>
                <el-table-column label="回答状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.answerstatus == 1" type="success">成功</el-tag>
                    <el-tag v-else-if="scope.row.answerstatus == 0" type="warning">失败</el-tag>
                    <el-tag v-else-if="scope.row.answerstatus == 'q'" type="danger">配额满</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="是否回退">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
                    <el-tag v-else type="warning">未回退</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="addtime" label="回答时间"></el-table-column>
              </el-table>
            </el-row>

            <el-row>
              <el-pagination background layout="prev, pager, next" :page-size="pageSize" :page-count="pages"
                style="margin-top: 20px;" @current-change="currentChange"></el-pagination>
            </el-row>
          </el-card>

          <el-card style="margin-top: 20px;">
            <div
              style="font-size: 18px;margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;">
              <div>肥牛卷专属链接</div>
              <div @click.stop="onTapFNModal" style="color: #409eff;cursor: pointer;">肥牛回退列表</div>
            </div>
            <el-row v-if="linkInfo && linkInfo.fn" style="margin: 20px 0;">
              <div @click.stop="onTapCopy(2)" style="color: #409eff;cursor: pointer;">
                {{ linkInfo.fn }}
              </div>
            </el-row>
            <template v-if="linkInfo && linkInfo.fn">
              <!-- 已申请 -->
              <el-row style="margin-bottom: 10px;">
                <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="f2" clearable></el-input>
                <el-select v-model="s2" placeholder="请选择回答结果" style="width: 250px;margin-left: 10px;">
                  <el-option v-for="e in ss" :key="e.value" :label="e.label" :value="e.value"></el-option>
                </el-select>
                <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh"
                  @click="onReset2">重置</el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSearch2">搜索</el-button>
              </el-row>

              <el-row>
                <el-table :data="list2" border stripe>
                  <el-table-column type="index" :index="index" :span="2"></el-table-column>
                  <el-table-column prop="prid" label="问卷ID"></el-table-column>
                  <el-table-column prop="nickName" label="昵称"></el-table-column>
                  <el-table-column prop="fromuid" label="来源用户"></el-table-column>
                  <el-table-column label="回答状态">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.answerstatus == 1" type="success">成功</el-tag>
                      <el-tag v-else-if="scope.row.answerstatus == 0" type="warning">失败</el-tag>
                      <el-tag v-else-if="scope.row.answerstatus == 'q'" type="danger">配额满</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否回退">
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
                      <el-tag v-else type="warning">未回退</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="addtime" label="回答时间"></el-table-column>
                </el-table>
              </el-row>

              <el-row>
                <el-pagination background layout="prev, pager, next" :page-size="pageSize" :page-count="pages2"
                  style="margin-top: 20px;" @current-change="currentChange2"></el-pagination>
              </el-row>
            </template>
            <template v-else>
              <!-- 没申请 -->
              <el-button type="primary" icon="el-icon-thumb" @click="onApplyFn">申请开通</el-button>
            </template>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 即付回退 -->
    <el-dialog title="即付回退列表" :visible.sync="isShowJFModal" width="70%" center :close-on-click-modal="false"
      :before-close="onModalClose">
      <el-row style="margin-bottom: 10px;">
        <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="modalF" clearable></el-input>
        <!--<el-select v-model="modalS" placeholder="请选择回答结果" style="width: 250px;margin-left: 10px;">
          <el-option v-for="e in ss" :key="e.value" :label="e.label" :value="e.value"></el-option>
        </el-select>-->
        <el-input placeholder="请输入问卷ID" style="width: 300px;margin-left: 10px;" v-model="modalS" clearable></el-input>
        <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh" @click="onModalReset">重置</el-button>
        <el-button type="primary" icon="el-icon-search" @click="onModalSearch">搜索</el-button>
      </el-row>
      <el-table :data="modalList" border stripe>
        <el-table-column type="index" :index="index" :span="2"></el-table-column>
        <el-table-column prop="prid" label="问卷ID"></el-table-column>
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        <el-table-column prop="fromuid" label="来源用户"></el-table-column>
        <el-table-column label="回答状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.answerstatus == 1" type="success">成功</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 0" type="warning">失败</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 'q'" type="danger">配额满</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否回退">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
            <el-tag v-else type="warning">未回退</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addtime" label="回答时间"></el-table-column>
      </el-table>
      <el-row>
        <el-pagination background layout="prev, pager, next" :page-size="100" :page-count="modalPages"
          style="margin-top: 20px;" @current-change="currentJFChange"></el-pagination>
      </el-row>
    </el-dialog>

    <!-- 肥牛回退 -->
    <el-dialog title="肥牛回退列表" :visible.sync="isShowFNModal" width="70%" center :close-on-click-modal="false"
      :before-close="onModalClose">
      <!-- <el-row style="margin-bottom: 10px;">
        <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="modalF" clearable></el-input>
        <el-select v-model="modalS" placeholder="请选择回答结果" style="width: 250px;margin-left: 10px;">
          <el-option v-for="e in ss" :key="e.value" :label="e.label" :value="e.value"></el-option>
        </el-select>
        <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh" @click="onModalReset">重置</el-button>
        <el-button type="primary" icon="el-icon-search" @click="onModalSearch">搜索</el-button>
      </el-row> -->
      <el-table :data="modalList" border stripe>
        <el-table-column type="index" :index="index" :span="2"></el-table-column>
        <el-table-column prop="prid" label="问卷ID"></el-table-column>
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        <el-table-column prop="fromuid" label="来源用户"></el-table-column>
        <el-table-column label="回答状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.answerstatus == 1" type="success">成功</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 0" type="warning">失败</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 'q'" type="danger">配额满</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否回退">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
            <el-tag v-else type="warning">未回退</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addtime" label="回答时间"></el-table-column>
      </el-table>
      <el-row>
        <el-pagination background layout="prev, pager, next" :page-size="100" :page-count="modalPages"
          style="margin-top: 20px;" @current-change="currentFNChange"></el-pagination>
      </el-row>
    </el-dialog>

    <!-- 鸡肉回退 -->
    <el-dialog title="鸡肉回退列表" :visible.sync="isShowJrModal" width="70%" center :close-on-click-modal="false"
      :before-close="onModalClose">
      <el-row style="margin-bottom: 10px;">
        <el-input placeholder="请输入来源用户ID" style="width: 300px;" v-model="modalF" clearable></el-input>
        <el-input placeholder="请输入问卷ID" style="width: 300px;margin-left: 10px;" v-model="modalS" clearable></el-input>
        <el-button style="margin-left: 10px;" type="danger" icon="el-icon-refresh" @click="onModalReset">重置</el-button>
        <el-button type="primary" icon="el-icon-search" @click="onModalSearch">搜索</el-button>
      </el-row>
      <el-table :data="modalList" border stripe>
        <el-table-column type="index" :index="index" :span="2"></el-table-column>
        <el-table-column prop="prid" label="问卷ID"></el-table-column>
        <el-table-column prop="nickName" label="昵称"></el-table-column>
        <el-table-column prop="fromuid" label="来源用户"></el-table-column>
        <el-table-column label="回答状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.answerstatus == 2" type="success">成功</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 4" type="warning">失败</el-tag>
            <el-tag v-else-if="scope.row.answerstatus == 5" type="danger">配额满</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否回退">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isHt > 0" type="success">已回退</el-tag>
            <el-tag v-else type="warning">未回退</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addtime" label="回答时间"></el-table-column>
      </el-table>
      <el-row>
        <el-pagination background layout="prev, pager, next" :page-size="100" :page-count="modalPages"
          style="margin-top: 20px;" @current-change="currentJrChange"></el-pagination>
      </el-row>
    </el-dialog>
  </section>
</template>

<script>
import { getCookie } from "../utils";

export default {
  data() {
    return {
      unionId: "",

      list: [],
      pageNum: 1,
      pageSize: 20,
      pages: 0,
      count: 0,

      uid: "",
      list2: [],
      pageNum2: 1,
      pages2: 0,
      pageSize2: 20,
      count2: 0,

      list3: [],
      pageNum3: 1,
      pages3: 0,
      pageSize3: 20,
      count3: 0,

      index: 1,

      f: "",
      s: "",
      f2: "",
      s2: "",
      f3: "",
      s3: "",
      ss: [
        {
          label: "成功",
          value: 1
        },
        {
          label: "失败",
          value: 0
        },
        {
          label: "配额满",
          value: "q"
        }
      ],

      ss3: [
        {
          label: "成功",
          value: 2
        },
        {
          label: "失败",
          value: 4
        },
        {
          label: "配额满",
          value: 5
        }
      ],

      linkInfo: null,

      isShowJFModal: false,
      isShowFNModal: false,
      isShowJrModal: false,
      modalList: [],
      modalPageNum: 1,
      modalPages: 0,
      modalF: '',
      modalS: '',
    };
  },
  mounted() {
    this.unionId = getCookie("unionId");
    this.getLinks();
    this.getList();
    this.getList2();
    this.getList3();
  },

  methods: {
    async getLinks() {
      const res = await this.$axios.get(
        `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/getTg?uid=${this.unionId
        }`
      );
      if (res.data.code == 1) {
        this.linkInfo = res.data.data;
      }
    },

    // 申请开通肥牛
    async onApplyFn() {
      const res = await this.$axios.get(
        `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/acopl?uid=${this.unionId
        }`
      );
      if (res.data.code == 1) {
        this.$message({
          message: "申请成功",
          type: "success"
        });
        this.getLinks();
      } else {
        this.$message({
          message: `申请失败，请重试`,
          type: "error"
        });
      }
    },

    async onTapCopy(type) {
      let text = "";
      if (type == 1) {
        text = this.linkInfo.jf;
      } else if (type == 2) {
        text = this.linkInfo.fn;
      }
      this.copyToClipboard(text);
    },

    copyToClipboard(text) {
      // 检查浏览器是否支持 Clipboard API
      if (navigator.clipboard && window.isSecureContext) {
        // 异步复制文本到剪贴板
        navigator.clipboard
          .writeText(text)
          .then(function () {
            this.$message({
              message: "复制成功",
              type: "success"
            });
          })
          .catch(function (err) {
            this.$message({
              message: "复制失败，请手动复制",
              type: "error"
            });
          });
      } else {
        // 如果不支持 Clipboard API 或者不是安全上下文（HTTPS），回退到其他方法
        this.fallbackCopyTextToClipboard(text);
      }
    },

    // 不支持 Clipboard API 的回退方案
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // 防止键盘输入导致页面滚动
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.$message({
            message: "复制成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "复制失败，请手动复制",
            type: "error"
          });
        }
      } catch (err) {
        this.$message({
          message: "复制失败，请手动复制",
          type: "error"
        });
      }

      document.body.removeChild(textArea);
    },

    async getList3() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcJrAnswer?pageSize=${this.pageNum3}&pageNum=10&uid=${this.unionId}`;
      if (this.f3) {
        url += `&f=${this.f3}`;
      }
      if (this.s3 === 2 || this.s3 === 4 || this.s3 === 5) {
        url += `&s=${this.s3}`;
      }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        this.list3 = res.data.data;
        this.pages3 = res.data.pages;
      }
    },

    async getList() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcAnswer?pageSize=${this.pageNum
        }&pageNum=10&uid=${this.unionId}`;
      if (this.f) {
        url += `&f=${this.f}`;
      }
      if (this.s === 0 || this.s === 1 || this.s === "q") {
        url += `&s=${this.s}`;
      }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        this.list = res.data.data;
        this.pages = res.data.pages;
      }
    },

    async getList2() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcFnAnswer?pageSize=${this.pageNum2
        }&pageNum=10&uid=${this.unionId}`;
      if (this.f2) {
        url += `&f=${this.f2}`;
      }
      if (this.s2 === 0 || this.s2 === 1 || this.s2 === "q") {
        url += `&s=${this.s2}`;
      }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        this.list2 = res.data.data;
        this.pages2 = res.data.pages;
      }
    },

    // 页码改变
    currentChange(e) {
      this.pageNum = e;
      this.getList();
    },

    // 页码改变
    currentChange2(e) {
      this.pageNum2 = e;
      this.getList2();
    },

    currentChange3(e) {
      this.pageNum3 = e;
      this.getList3();
    },

    // 筛选
    onSearch() {
      this.pageNum = 1;
      this.getList();
    },

    // 筛选
    onSearch2() {
      this.pageNum2 = 1;
      this.getList2();
    },

    onSearch3() {
      this.pageNum3 = 1;
      this.getList3();
    },

    onReset() {
      this.f = "";
      this.s = "";
      this.pageNum = 1;
      this.getList();
    },

    onReset3() {
      this.f3 = "";
      this.s3 = "";
      this.pageNum3 = 1;
      this.getList3();
    },

    currentJFChange(e) {
      this.modalPageNum = e;
      this.onTapJFModal();
    },

    currentFNChange(e) {
      this.modalPageNum = e;
      this.onTapFNModal();
    },

    currentJrChange(e) {
      this.modalPageNum = e;
      this.onTapJrModal();
    },

    onModalClose() {
      this.modalF = "";
      this.modalS = "";
      this.modalPageNum = 1;
      this.modalList = [];
      this.modalPages = 0;
      this.isShowJFModal = false
      this.isShowFNModal = false;
      this.isShowJrModal = false
    },

    onReset2() {
      this.f2 = "";
      this.s2 = "";
      this.pageNum2 = 1;
      this.getList2();
    },

    onToLog() {
      this.$router.push("/log");
    },

    onModalReset() {
      this.modalF = "";
      this.modalS = "";
      this.modalPageNum = 1;
      this.modalList = [];
      this.modalPages = 0;
      if (this.isShowJFModal) {
        this.onTapJFModal()
      } else if (this.isShowFNModal) {
        this.onTapFNModal()
      } else if (this.isShowJrModal) {
        this.onTapJrModal()
      }
    },

    onModalSearch() {
      this.modalPageNum = 1;
      if (this.isShowJFModal) {
        this.onTapJFModal()
      } else if (this.isShowFNModal) {
        this.onTapFNModal()
      } else if (this.isShowJrModal) {
        this.onTapJrModal()
      }
    },

    async onTapJrModal() {
      // let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcJfHt?pageSize=100&pageNum=${this.modalPageNum}&uid=${this.unionId}`;
      // if (this.modalF) {
      //   url += `&f=${this.modalF}`;
      // }
      // if (this.modalS) {
      //   url += `&prId=${this.modalS}`;
      // }
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcJrAnswer?pageSize=${this.modalPageNum}&pageNum=100&uid=${this.unionId}&ht=1`;
      if (this.modalF) {
        url += `&f=${this.modalF}`;
      }
      if (this.modalS) {
        url += `&s=${this.modalS}`;
      }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        // res.data.data = res.data.data.filter(e => e.isHt == 1)
        this.modalList = res.data.data;
        this.modalPages = res.data.pages;

        this.isShowJrModal = true
      }
    },

    async onTapJFModal() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcJfHt?pageSize=100&pageNum=${this.modalPageNum}&uid=${this.unionId}`;
      if (this.modalF) {
        url += `&f=${this.modalF}`;
      }
      if (this.modalS) {
        url += `&prId=${this.modalS}`;
      }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        res.data.data = res.data.data.filter(e => e.isHt == 1)
        this.modalList = res.data.data;
        this.modalPages = res.data.pages;

        this.isShowJFModal = true
      }
    },

    async onTapFNModal() {
      let url = `https://home.51point.com/51point-0.0.1-SNAPSHOT/opAdmin/pcFnHt?pageSize=100&pageNum=${this.modalPageNum
        }&uid=${this.unionId}`;
      // if (this.modalF) {
      //   url += `&f=${this.modalF}`;
      // }
      // if (this.modalS === 0 || this.modalS === 1 || this.modalS === "q") {
      //   url += `&s=${this.modalS}`;
      // }
      const res = await this.$axios.get(url);
      if (res.data.code == 1) {
        res.data.data = res.data.data.filter(e => e.isHt == 1)
        this.modalList = res.data.data;
        this.modalPages = res.data.pages;

        this.isShowFNModal = true
      }
    }
  }
};
</script>

<style scoped>
.index .gc-qrcode-img {
  width: 125px;
  height: 125px;
  margin: 20px auto;
}

.index .wxssk {
  font-size: 12px;
  color: #666666;
  text-align: center;
}

.index .gc-qrcode-ctx {
  width: 160px;
  height: 200px;
  background: #ffffff;
  border: 1px solid #efefef;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
  border-radius: 2px;
}

.index .gc-qrcode {
  position: absolute;
  bottom: 20px;
  right: 15px;
}

.index .gc-qrtime {
  position: absolute;
  bottom: 20px;
  left: 15px;
  font-size: 10px;
  color: #999;
}

.index .gc-qrcode-text {
  font-size: 13px;
  color: #959499;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  /* width: 60px; */
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  float: right;
  margin-top: 10px;
  cursor: pointer;
}

.index .gc-qrcode-text:hover {
  background: #c9c9ce;
  border-color: #c9c9ce;
  color: #fff;
}

.index .gc-page {
  float: left;
  /* margin-right: 20px; */
  margin-left: 10px;
  margin-right: 10px;
}

.index .gc-category {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 2;
  border-radius: 100px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 11px;
  color: #ffffff;
  padding: 5px;
}

.index .gc-page-bottom {
  position: absolute;
  bottom: 20px;
  z-index: 2;
  left: 15px;
  height: 16px;
  line-height: 16px;
  width: 150px;
  font-size: 12px;
  color: #9b9b9b;
}

.index .gc-headImg-ctx {
  position: absolute;
  top: 125px;
  left: 15px;
  z-index: 2;
  width: 32px;
  height: 32px;
}

.index .gc-headImg {
  width: 32px;
  height: 32px;
  border-radius: 32px;
  border: 2px solid #ffffff;
}

/* .index .gc-page-top{
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
} */
.index .gc-page-top {
  width: 280px;
  height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: center; */
  justify-content: flex-end;
}

.index .gc-page-center {
  position: relative;
  padding: 15px;
  padding-top: 25px;
}

.index .gc-nickname {
  font-size: 13px;
  color: #666666;
  margin-bottom: 15px;
}

.index .gc-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 12px;
  line-height: 22px;
}

.index .gc-subtitle {
  font-size: 12px;
  color: #888888;
  line-height: 18px;
  /* max-height: 54px; */
  overflow: hidden;
}

.index .gc-page {
  width: 280px;
  height: 360px;
  background: #ffffff;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
}

.index .gc-page:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.index .container {
  min-height: 540px;
  padding: 20px 20px;
}

.index .gc-page-top img {
  width: 100%;
  height: 100%;
  background: gray;
}

.noQ {
  display: block;
  padding-top: 20px;
}

.noQ p {
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 28px;
}

.noQ-div {
  width: 260px;
  height: 196.48px;
  margin: 0 auto;
  background-size: 360px 196.48px;
  padding-top: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.noQ .noQ-link {
  color: #65ae71;
  border-bottom: 3px double #65ae71;
}

.noQ-btn {
  font-size: 16px;
  margin-top: 10px;
  color: white;
  /* background: #DF7F7D; */
  background: #65ae71;
  height: 40px;
  width: 120px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.noQ div:nth-of-type(2) {
  width: 47px;
  height: 77px;
  margin: 10px auto 0;
  background: url(../assets/img/zhanwuicon@2x.png) center no-repeat;
  background-size: 47px 77px;
}

.done {
  background: #9fc2e2;
}

.ing {
  background: #d4b7b5;
}

.filteer-top {
  background-color: #65ae71;
}

/* .done-status {
  position: relative;
  left: 110px;
  top: 118px;
  color: white;
} */

.ing-status {
  position: relative;
  left: 115px;
  top: 110px;
  color: white;
}

.ing-status span {
  font-size: 160%;
  margin-right: 4px;
}

/*  */
.shuomin {
  color: #999;
  font-size: 14px;
  /* margin: 20px 0px;
  padding-left: 10px; */
  /* width: calc(100% - 10px); */
}

.gc-page-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 0 auto;
}

.index .container-center {
  margin: 0 auto;
  overflow: hidden;
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start; */
}

/* 手机 */
@media screen and (max-width: 768px) {
  .index .container-center {
    width: 300px;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .index .container-center {
    width: 600px;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .index .container-center {
    width: 900px;
  }
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
  .index .container-center {
    width: 1200px;
  }
}

.done-status {
  /* position: relative;
  left: 105px;
  top: 8px; */
  /* width: 280px;
  height: 360px; */
  color: white;
  display: flex;
  flex-direction: row-reverse;
  margin-right: 5px;
  margin-bottom: 5px;
}

.gc-money {
  color: white;
  font-size: 80px;
  text-align: center;
  margin-bottom: -10px;
  /* font-weight: 545; */
}

.gc-money span {
  font-size: 20px;
  margin-left: 5px;
  /* font-weight: normal; */
}

.index .gc-page-tmp {
  /* float:left; */
  margin-left: 10px;
  margin-right: 10px;
  width: 280px;
  height: 360px;
  background: #ffffff;
  /* cursor: pointer; */
  position: relative;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.index .gc-page-tmp:hover {
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);
}

.top-point {
  font-size: 48px;
  color: white;
  margin-bottom: 30px;
}

.top-point span {
  font-size: 15px;
  margin-left: 5px;
}

.top-title {
  font-size: 14px;
  color: #fff;
  margin-left: 10px;
}

.top-title span {
  opacity: 0.5;
  font-size: 12px;
  margin-left: 10px;
  color: #fff;
}

.top-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.top-bottom img {
  height: 18px;
  width: 18px;
  margin-right: 10px;
}

.top-notice {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-top: 10px;
}

.top-bg {
  height: 40%;
  width: 100%;
  background: #e3696a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.top-bg-green {
  height: 40%;
  width: 100%;
  background: #65ae71;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.bg-btn {
  width: 90%;
  height: 45px;
  color: white;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  /* margin-top: 20px; */
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-btn-zhuan {
  width: 90%;
  height: 43px;
  color: #e3696a;
  border: 1px solid #e3696a;
  display: block;
  border-radius: 4px;
  font-size: 15px;
  line-height: 45px;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.zhuan {
  background: #e3696a;
}

.zhuan-green {
  background-color: #65ae71;
  /* margin-top: 8px; */
}

.exit {
  background: #f16754;
}

.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
  padding: 12px 8px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.top-row-title {
  font-size: 14px;
  color: #333;
}

.top-row-detail {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}

/*点子不足*/
.noEnoughWin {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 2px 0;
}

.noEnoughWin-2 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px 2px 0;
}

.noEnoughWin-2-div {
  width: 20%;
  margin: 10% auto 0 auto;
  background: #fff;
  border-radius: 4px;
  padding: 18px 45px 26px;
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

.noEnoughWin div {
  width: 20%;
  margin: 10% auto 0 auto;
  background: #fff;
  border-radius: 4px;
  padding: 18px 45px 26px;
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

.noEnoughWin div h4 {
  font-size: 15px;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
}

.noEnoughWin-2-div h4 {
  font-size: 15px;
  color: #333;
  text-align: center;
  margin-bottom: 16px;
}

.noEnoughWin div p {
  font-size: 14px;
  color: #999;
  text-align: center;
  margin-bottom: 20px;
}

.noEnoughWin-2-div p {
  font-size: 14px;
  color: rgb(7, 2, 2);
  text-align: center;
  margin-bottom: 20px;
  word-break: break-all;
  line-height: 120%;
  cursor: pointer;
}

.noEnoughWin div a {
  display: block;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: #e3696a;
  border-radius: 8px;
  line-height: 44px;
  cursor: pointer;
}

.ev-cancel {
  display: block;
  font-size: 14px;
  text-align: center;
  color: #e3696a;
  background-color: white;
  border: 1px solid #e3696a;
  border-radius: 8px;
  line-height: 44px;
  cursor: pointer;
  flex: 1;
}

.ev-entry {
  display: block;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: #e3696a;
  border-radius: 8px;
  line-height: 44px;
  cursor: pointer;
  flex: 1;
  margin-left: 8px;
}

@keyframes fadeInDown {
  0% {
    -webkit-transform: translate3d(0, -20%, 0);
    -webkit-transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    transform: translate3d(0, -20%, 0);
    opacity: 0;
  }

  100% {
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}

/*提现输入电子数*/
.importWin {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 61px 20px 0;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
}

.importWin-top-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.close {
  width: 14px;
  height: 14px;
  border: 0;
}

.left {
  opacity: 0;
}

/*输入提现电子数*/
.point {
  background: #fff;
  border-radius: 4px;
  padding: 22px 20px 30px;
  /* margin: 5% 32%; */
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
  width: 20%;
  margin: 10% auto 0 auto;
}

.point h4 {
  font-size: 18px;
  color: #333;
  text-align: center;
}

.point p:nth-of-type(1) {
  font-size: 14px;
  color: #333;
  margin-bottom: 21px;
}

.my-idea {
  font-size: 14px;
  color: #333;
  margin-bottom: 21px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.my-idea-y {
  font-size: 14px;
  color: #333;
  margin-bottom: 21px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.my-idea-t {
  font-size: 14px;
  color: #333;
}

.dot {
  font-size: 24px;
  color: #e3696a;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.dot .idea {
  margin-bottom: -2px;
}

.dot .dot-dot {
  font-size: 14px;
  margin-left: 4px;
  color: #e3696a;
}

.point p:nth-of-type(2) {
  font-size: 14px;
  color: #333;
  margin-bottom: 22px;
}

.point p:nth-of-type(2) text {
  display: inline-block;
  float: right;
  color: #e3696a;
}

.point p:nth-of-type(3) {
  border-bottom: 1px solid #ccc;
  padding-bottom: 8px;
}

.point p:nth-of-type(3) input {
  font-size: 36px;
  /* width: 28rem; */
  width: 100%;
}

.point p:nth-of-type(3) input::input-placeholder {
  color: #999;
}

.point p:nth-of-type(3) text {
  font-size: 14px;
  color: #333;
}

.point .button {
  font-size: 15px;
  color: #fff;
  background: #e3696a;
  border-radius: 8px;
  line-height: 44px;
  width: 100%;
  margin-top: 30px;
  display: flex;
  align-content: center;
  justify-content: center;
  cursor: pointer;
}

.check-btn {
  font-size: 15px;
  color: #fff;
  /* background: #65ae71; */
  background: #999;
  border-radius: 8px;
  /* line-height: 4.4rem; */
  height: 44px;
  width: 100%;
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.active {
  background: #65ae71;
}

/*核对真实姓名*/
.checkName {
  padding: 19px 30px 29px;
  background: #fff;
  border-radius: 4px;
  /* margin: 5% 32%; */
  -webkit-animation: fadeInDown 0.3s;
  animation: fadeInDown 0.3s;
}

.checkName h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

.checkName input {
  font-size: 14px;
  /* width: 23.5rem; */
  width: 80%;
  /* height: 5rem; */
  height: 40px;
  border: 1px solid #d8d8d8;
  border-radius: 8px;
  padding-left: 10px;
  margin: 0 auto 10px;
  display: block;
}

.checkName p {
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  color: #999;
}

.checkName .button {
  font-size: 15px;
  color: #fff;
  line-height: 44px;
  text-align: center;
  background: #65ae71;
  border-radius: 8px;
  margin-top: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

#inputPoint {
  width: calc(100% - 20px);
  height: 40px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  padding: 0 10px;
}

/* WebKit browsers */
::-webkit-input-placeholder {
  color: #777;
}

/* Mozilla Firefox 4 to 18 */
:-moz-placeholder {
  color: #777;
  opacity: 1;
}

/* Mozilla Firefox 19+ */
::-moz-placeholder {
  color: #777;
  opacity: 1;
}

/* Internet Explorer 10+ */
:-ms-input-placeholder {
  color: #777;
}

.sec-err {
  background: #feedee;
  color: #f46969;
  font-size: 12px;
  padding: 10px 20px;
  border-radius: 4px;
  margin-top: 20px;
}

.share-qrcode-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: #666;
  font-size: 12px;
}

.share-qrcode {
  position: absolute;
  right: 10px;
  bottom: 10px;
  width: 200px;
  height: 200px;
  background-color: white;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
}

.download-btn {
  margin-left: 10px;
  background-color: #e3696a;
  color: white;
  border: none;
  outline: none;
  border-radius: 4px;
  padding: 0 12px;
}

.cancel-btn {
  margin-left: 10px;
  background-color: transparent;
  color: #e3696a;
  border: 1px solid #e3696a;
  border-radius: 4px;
  padding: 0 12px;
}

/* 更新说明 */
.up-t {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.up-date {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-top: 20px;
}

.up-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-top: 10px;
  margin-bottom: 20px;
}

.up-desc {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
  line-height: 150%;
}

.up-link {
  color: #409eff;
  margin: 20px 0;
}

.up-more {
  color: #409eff;
  font-size: 14px;
  text-align: end;
  cursor: pointer;
}
</style>
